import { Injectable } from '@angular/core';
import { MessageService } from './message.service';

/**
 * this service is primarily used for inter-component communication
 * Components should auth_register via registerComponent() and unregister via unregisterComponent()
 * to notify a component use sendData()
 */
@Injectable()
export class CommunicationService {
  private map = new Map<string, Listener<any>>();

  constructor(private messageService: MessageService) {
  }

  /**
   * registers a component so that component can be notified
   * @param {string} id a unique id so the component can be identified
   * @param {Listener} obj the object that will be notified
   */
  registerComponent(id: string, obj: Listener<any>): void {
    this.messageService.sendTrace(`Component registered with id ${id}`);
    this.map.set(id, obj);
  }

  /**
   * sends the data to the component with the id
   * @param {string} id the id of the component to send the data to
   * @param data the data to send
   * @returns {boolean} true if a component could be found, false otherwise
   */
  sendData(id: string, data: any): boolean {
    if (this.map.has(id)) {
      this.map.get(id).onCommunicationEvent(data);
      return true;
    }
    return false;
  }

  /**
   * Send 'data' to all registered listeners
   * @param data
   */
  sendToAll(data: any) {
    this.map.forEach(listeningComponent => {
      listeningComponent.onCommunicationEvent(data);
    });
  }

  /**
   * removes the component so it doesn't receive notifications anymore
   * @param {string} id the id of the component to remove
   */
  unregisterComponent(id: string) {
    this.map.delete(id);
  }
}

export interface Listener<T> {
  onCommunicationEvent(data: T): void;
}
